import BaseApi from '@/includes/services/BaseApi'
import { ChatkeeperConfig } from "@/components/Flow/Nodes/Additionally/IntegrationCustom/types";
import { BaseBoardRequest } from "@/includes/types/Api.types";

export default class IntegrationApi {
    static async getChatkeeperConfig(type: string, body: BaseBoardRequest<{ token: string }>) {
        return BaseApi.sendRequest<{ config: ChatkeeperConfig }>(type, 'getchatkeeperconfig', body)
    }
}